export const dataHooks = {
  tooltip: 'inputArea-tooltip',
};

export const dataAttr = {
  SIZE: 'data-size',
  STATUS: 'data-status',
  RESIZABLE: 'data-resizable',
  DISABLED: 'data-disabled',
  HOVER: 'data-hover',
  FOCUS: 'data-focus',
};
